import { useState } from 'react';
import { useUser } from "../context/UserContext";
import axios from 'axios';
import config from '../config';
import Layout from '../layout/Layout';
import Form from '../components/Form';
import PageLogo from '../components/PageLogo';
import PageTitle from '../components/PageTitle';
import FormField from '../components/FormField';
import ButtonSubmit from '../components/ButtonSubmit';
import LoginGoogle from '../components/LoginGoogle';
import LoginFacebook from '../components/LoginFacebook';
import { toast } from 'react-toastify';

export default function ForgotPassword({ setCurrentPage }) {
    const { user, setUser } = useUser();
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'email') {
            setUser((prevUser) => ({
                ...prevUser,
                [name]: value.toLowerCase(),
            }));
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: value.trim(),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (user.email === '') {
            toast.info('Please enter your email address');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${config.apiBaseUrl}/auth/forgot-password/${user.email}`);

            toast.dismiss();
            setTimeout(() => {
                toast.info('A reset password email has been sent to you', {
                autoClose: false,
                });
            }, 500);
            setTimeout(() => {
                toast.success('Please reset your password using the link in the email', {
                autoClose: false,
                });
            }, 3500);
            setTimeout(() => {
                toast.info('Or, click the "Send" button again to recieve another email', {
                autoClose: false,
                });
            }, 7000);

        } catch (err) {
            toast.error('An error occurred. Please try again.');
        
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Form handleSubmit={handleSubmit}>
                <PageLogo />
                <PageTitle pageTitle={"Forgot Password"} />
                <p className="mt-2 text-center text-sm text-orange-200">
                    Pleaee enter your email address
                </p>
                
                <FormField
                    label={"Email"}
                    name={"email"}
                    type={"email"}
                    value={user.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoFocus={true}
                />

                <ButtonSubmit 
                    loading={loading} 
                    labeling={'Sending ...'} 
                    label={'Send Reset Link'} 
                    disabled={loading}
                />

                <div className="mt-4 text-gray-200 text-center">
                    You did not mean it?{" "}
                    <button
                        key='login'
                        onClick={(e) => {
                            e.preventDefault();
                            setCurrentPage('login')
                        }}
                        className="text-orange-300 hover:underline"
                    >
                        Please Login
                    </button>
                </div>

                <div className="mt-4 text-gray-200 text-center">
                    Do not have an account yet?{" "}
                    <button
                        key='signup'
                        onClick={() => setCurrentPage('signup')}
                        className="text-orange-300 hover:underline"
                    >
                        Please Sign Up
                    </button>
                </div>

                <div className="border-t text-gray-200 my-4 text-center">
                    Or, login using below:
                </div>

                <div className='flex justify-center items-center'>
                    <LoginGoogle/>

                    <LoginFacebook
                        setLoading={setLoading}
                    />
                </div>
            </Form>
        </Layout>
    );
}

